import {AxiosError} from 'axios';
import {useMutation} from 'react-query';
import {toast} from 'react-toastify';
import PatchFertilizerRequirement from '.';

interface IPostFertilizerRequirementProps {
  onSuccess?: (data: any) => void;
  guid?: string;
}

const usePatchFertilizerRequirement = ({
  onSuccess,
  guid,
}: IPostFertilizerRequirementProps) => {
  const data = useMutation({
    mutationFn: (payload: IFertilizerRequirementPayload) => {
      return PatchFertilizerRequirement(payload, guid);
    },
    onSuccess: data => {
      onSuccess && onSuccess(data);
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return data;
};

export {usePatchFertilizerRequirement};
